import { PRODUCT_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useProductList } from './hook';
import { ProductListProps } from './props';

export const ProductList = ({ filters }: ProductListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useProductList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${PRODUCT_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
